module.exports = __webpack_public_path__ + "static/media/locasty-text.439bb401.svg";